<div class="text-field {{ state }}">
  <div class="content">
    <label>
      <input 
        (ngModelChange)="updateChanges()"
        type="{{type}}" 
        id="{{ id }}" 
        class="{{ inputStyle }}" 
        [(ngModel)]="valueInput" 
        name="text-field" 
        [required]="true" 
        (keyup)="clearErrorStyle(); showErrorState(); countChars($event)" 
        (change)="validateField()"
        input-directive 
        [minLength]=minLength 
        [maxLength]=maxLength 
        [pattern]="patternInput" 
        (setState)="onSetStateChange($event)" 
        (click)="validateField()" 
        [disabled]="(state == 'disabled')" 
        autocomplete="off" 
        onPaste="return false" 
        onCopy="return false"
        (blur)="focusOutEvent($event)"
        [autofocus]='focusElement'
      >
      <span [ngClass]="{'disable-input' : valueInput}">{{ label }}</span>
      <div class="icon mx-2">
        <app-tooltip *ngIf="tooltipMessage || (imageTooltip &&( valueInput === undefined || valueInput === ''))" icon="{{ iconPrimary }}" idTooltip="{{idTooltip}}" title="{{tooltipMessage}}" type="{{typeTooltip}}" image="{{imageTooltip}}"></app-tooltip>
        <img *ngIf="iconSecondary" [src]="srcIconSecondary" class="{{state}}" (click)="clearField()" alt="icon">
      </div>
    </label>
  </div>
  <div class="sub-content m-2">
    <p class="message">{{ message }}</p>
    <p *ngIf="counter">{{ charsCounter }}/{{ maxLength }}</p>
  </div>
</div>
